import React from "react";
import style from "./style.scss";
import cn from "classnames";

const main =
  "© 2026 Optum, Inc. All rights reserved. Optum® is a registered trademark of Optum, Inc.";
const alternative =
  "Optum® is a registered trademark of Optum, Inc. in the U.S. and other jurisdictions. All other brand or product names are trademarks or registered marks or the property of their respective owners. Optum is an equal opportunity employer.";

const Footer = ({ mainText }) => (
  <div className={cn(style.root)}>
    <div className={cn(style.footer, !mainText && style.alternative)}>
      <p>{mainText ? main : alternative}</p>
    </div>
    <div className={cn(style.links)}>
      <div> <a target="_blank" href="https://www.optum.com/en/privacy-policy.html">Privacy</a></div>
      <div> <a target="_blank" href="https://www.optum.com/en/terms-of-use.html">Terms of Use</a></div>
      <div> <a target="_blank" href="https://www.optum.com/en/language-assistance-nondiscrimination.html">Non-Discrimination Notice</a></div>
    </div>
  </div>
);

export default Footer;
